import React from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import NumberFormat from "react-number-format";
import {
  MANAGER_FEE_LIST_QUERY,
  MANAGER_DONATION_LIST_QUERY,
} from "../Queries";

export default withRouter(() => {
  const { data: fData, loading: fLoading } = useQuery(MANAGER_FEE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });
  const { data: dData, loading: dLoading } = useQuery(
    MANAGER_DONATION_LIST_QUERY,
    { fetchPolicy: "network-only" }
  );

  if (fLoading || dLoading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  const fees = (fData && fData.ManagerFeeList) || [];
  const donations = (dData && dData.ManagerDonationList) || [];

  // 회비 총 잔액(DRM 트러스트라인 합)
  const feeBalance = fees.reduce((sum, fee) => {
    const drm =
      (fee.trustlines || []).find((t) => t.currency === "DRM") || {};
    return sum + (drm.amount || 0);
  }, 0);

  // 기부 총 모금액(DRM 합)
  const donationTotal = donations.reduce(
    (sum, d) => sum + (d.totalDRM || 0),
    0
  );

  const cardStyle = {
    display: "block",
    background: "#fff",
    borderRadius: 4,
    padding: "20px 22px",
    boxShadow: "0 1px 1px rgba(0,0,0,.08)",
    color: "#2d353c",
    height: "100%",
  };

  return (
    <>
      <Helmet>
        <title>담당자 대시보드 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item active">대시보드</li>
        </ol>
        <h1 className="page-header">담당자 대시보드</h1>

        <div className="row">
          <div className="col-md-6 m-b-15">
            <Link to="/manager/fees" style={cardStyle}>
              <div className="text-muted f-s-13 m-b-5">
                <i className="far fa-calendar-check m-r-5"></i>담당 회비
              </div>
              <div className="f-s-28 f-w-600">
                {fees.length}
                <span className="f-s-14 f-w-400"> 건</span>
              </div>
              <div className="text-muted f-s-12 m-t-5">
                총 합계{" "}
                <NumberFormat
                  value={feeBalance}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                DRM
              </div>
              <div className="text-blue f-s-12 m-t-10">회비 관리 →</div>
            </Link>
          </div>

          <div className="col-md-6 m-b-15">
            <Link to="/manager/donations" style={cardStyle}>
              <div className="text-muted f-s-13 m-b-5">
                <i className="far fa-heart m-r-5"></i>담당 기부
              </div>
              <div className="f-s-28 f-w-600">
                {donations.length}
                <span className="f-s-14 f-w-400"> 건</span>
              </div>
              <div className="text-muted f-s-12 m-t-5">
                총 모금액{" "}
                <NumberFormat
                  value={donationTotal}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                DRM
              </div>
              <div className="text-blue f-s-12 m-t-10">기부 관리 →</div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
});
